function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { message, Descriptions } from "antd";
import NewAppointment from "./forms/NewAppointment";
import Common from "./includes/Common";
import { PhoneFill } from 'react-bootstrap-icons';
import Moment from "react-moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Appointment = function Appointment() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      appointments = _useState2[0],
      setAppiontments = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDataLoading = _useState4[0],
      setIsDataLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dataChanged = _useState6[0],
      setDataChanged = _useState6[1];

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getappointments/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setAppiontments(response.data.appointments);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "white-bg cool-radius",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 7,
            md: 8,
            children: [/*#__PURE__*/_jsx("h4", {
              children: "MES RENDEZ-VOUS"
            }), appointments.map(function (a) {
              return /*#__PURE__*/_jsxs(Descriptions, {
                style: {
                  marginBottom: '10px'
                },
                size: "small",
                bordered: true,
                column: 1,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Patient"
                  }),
                  children: a.customer.firstname + " " + a.customer.lastname + " (" + a.customer.idnumber + ")"
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Raison",
                  children: a.reason
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Date",
                  children: /*#__PURE__*/_jsx(Moment, {
                    locale: "Fr",
                    format: "DD/MM/YYYY hh:mm",
                    children: a.date
                  })
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx(PhoneFill, {
                    size: 20
                  }),
                  children: a.customer.mobile.slice(3)
                })]
              }, a.id);
            }), isDataLoading && appointments.length == 0 && /*#__PURE__*/_jsx("div", {
              children: "Vous n'avez aucun rendez-vous"
            })]
          }), /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 4,
            children: /*#__PURE__*/_jsx("div", {
              className: "cool-radius r-bg",
              children: /*#__PURE__*/_jsx(NewAppointment, {
                handler: function handler() {
                  setDataChanged(true);
                }
              })
            })
          })]
        })
      })
    })
  });
};

export default Appointment;